// gimme: conversations-inbox-ui/ 06/02/2020 5f1e15ece5fe518f7ad7313590340d8fe6192284
'use es6';

import { createSelector } from 'reselect';
import { getFocusedThreadDetails } from '../../thread-details/selectors/getFocusedThreadDetails';
import { getVid } from 'conversations-thread-data/thread-details/public/operators';
export const getCurrentVid = createSelector([getFocusedThreadDetails], threadDetails => getVid(threadDetails) || threadDetails && threadDetails.visitor && threadDetails.visitor.vid);
export default getCurrentVid;